import { LogInIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@repo/ui/components/common';
import { cn } from '@repo/utils/common';

import { usePortalUrls } from '@/client/hooks/portal.hooks';

interface PartnerPortalLinkProps {
  className?: string;
}

export const PartnerPortalLink = ({ className }: PartnerPortalLinkProps) => {
  const { t } = useTranslation();

  const { portalUrl } = usePortalUrls();

  return (
    <Button
      asChild
      variant="outline"
      className={cn(
        'border-white bg-transparent font-bold text-white hover:bg-white hover:text-black',
        className,
      )}
    >
      <a href={portalUrl} aria-label={t('portal.ariaLabel')}>
        <LogInIcon />
        <span className="hidden sm:inline">{t('portal.buttonText')}</span>
        <span className="sm:hidden">{t('portal.buttonTextShort', 'Portal')}</span>
      </a>
    </Button>
  );
};
